<template>
  <v-form ref="userForm" lazy-validation>
    <v-container fluid class="pt-0 mt-0">
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <v-row class="mt-0 mb-0 pt-0 pb-0">
        <v-spacer />
        <v-col cols="12" md="11" class="mt-0 mb-0 pt-0 pb-0">
          <h1 v-if="apiData && apiData.length > 0">
            {{ actionDescription }} '{{ apiData[0].subject }}'
          </h1>
          <span v-else class="mt-0 mb-0 pt-0 pb-0">
            <v-row class="mt-0 mb-0 pt-0 pb-0">
              <v-col cols="12">
                <h1 v-html="actionDescription + ' \'' + topicTitle + '\''"></h1>
              </v-col>
            </v-row>
            <v-row
              class="mt-0 mb-0 pt-0 pb-0"
              v-if="loggedOnUserIsAdmin && postIsNewTopic"
            >
              <v-col cols="6" class="mt-0 mb-0 pt-0 pb-0">
                <v-checkbox
                  class="mt-0 mb-0 pt-0 pb-0"
                  v-model="topicSticky"
                  label="Sticky?"
                  color="primary"
                  :true-value="1"
                  :false-value="0"
                  @click="topicStickyClicked()"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="6" class="mt-0 mb-0 pt-0 pb-0">
                <v-checkbox
                  class="mt-0 mb-0 pt-0 pb-0"
                  v-model="topicAnnouncement"
                  label="Announcement?"
                  color="primary"
                  :true-value="1"
                  :false-value="0"
                  @click="topicAnnouncementClicked()"
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </span>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row
        v-if="
          !$route.params.topic_id ||
          !$route.params.post_id ||
          (userIsTopicOwner && apiOperation == 'update') ||
          (loggedOnUserIsAdmin && apiOperation == 'update')
        "
        class="mt-0 mb-0 pt-0 pb-0"
      >
        <v-spacer />
        <v-col cols="12" md="11" class="mt-0 mb-0 pt-0 pb-0">
          <v-text-field
            class="mt-0 mb-0 pt-0 pb-0"
            ref="topicTitle"
            clearable
            outlined
            :rules="titleRules"
            shaped
            persistent-hint
            label="What is your post title?"
            hint="The title should be no more than 150 characters"
            counter="150"
            v-model="postTitle"
          >
          </v-text-field>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row v-if="!this.editorContent == null">
        <v-spacer />
        <v-col cols="11">
          <h2>Loading Editor...</h2>
        </v-col>
        <v-spacer />
      </v-row>

      <v-row v-if="this.editorContent != null">
        <v-spacer />
        <v-col cols="12" md="11">
          <em class="pa-1" style="color: red"
            ><b
              >To review our <a @click="showRulesPanel()">Forum Posting Rules</a>, or if
              you need <a @click="showHelpPanel()">Help</a> using the forum editor
              including how to add images & links, please click the relevant buttons
              below</b
            ></em
          >

          <editor
            ref="editorElement"
            api-key="obkrlht14x57mdol58bxqewvhlp88c5lwfj2i9d770gpxomq"
            initial-value="<br/>"
            v-model="editorContent"
            id="contentEditor"
            :init="{
              selector: 'textarea',
              height: 360,
              menubar: false,
              toolbar_mode: 'wrap',
              mobile: {
                toolbar_mode: 'wrap',
              },
              style_formats: [
                {
                  title: 'Image Left',
                  selector: 'img',
                  styles: {
                    float: 'left',
                    margin: '0 10px 0 10px',
                  },
                },
                {
                  title: 'Image Right',
                  selector: 'img',
                  styles: {
                    float: 'right',
                    margin: '0 10px 0 10px',
                  },
                },
              ],
              setup: editorSetup,
              plugins: [
                'emoticons',
                'lists',
                'advlist',
                'link',
                'anchor',
                'image',
                'media',
                'help',
              ],
              toolbar:
                'undo redo bold italic underline fontsize forecolor | bullist emoticons | copy paste pastetext | link image media helpButton memberRulesButton help',
              help_tabs: ['shortcuts'],
              contextmenu: false,
              content_css: false,
              convert_urls: true,
              relative_urls: false,
              browser_spellcheck: true,
              skin: false,
              content_style: contentUiCss.toString() + '\n' + contentCss.toString(),
              smart_paste: true,
              paste_data_images: true,
              paste_preprocess: preProcessPaste,
            }"
          />
        </v-col>

        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="6" sm="2" class="text-left">
          <v-btn class="ma-2 error eps_white" outlined @click="cancelEdit()"
            >Cancel
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--right mdi mdi-cancel theme--light"
              style="font-size: 16px"
            ></i>
          </v-btn>
        </v-col>

        <v-col cols="6" sm="4">
          <v-alert
            type="error"
            dismissible
            close-text="Close Alert"
            border="left"
            dense
            :value="showError"
            @input="showError = false"
          >
            {{ errorMessage }}</v-alert
          >
        </v-col>

        <v-col cols="6" sm="3" class="text-left">
          <v-btn class="ma-2 teal eps_white" outlined @click="showUploadImage()">
            Attach Image
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--right mdi mdi-camera theme--light"
              style="font-size: 16px"
            ></i>
          </v-btn>
        </v-col>

        <v-col cols="6" sm="2" class="text-right">
          <v-btn class="ma-2 teal eps_white" outlined @click="submitPost()">
            Submit
            <i
              aria-hidden="true"
              class="v-icon notranslate v-icon--right mdi mdi-email-newsletter theme--light"
              style="font-size: 16px"
            ></i>
          </v-btn>
        </v-col>

        <v-spacer />
      </v-row>

      <v-row>
        <v-spacer />
        <v-col cols="11" md="11">
          <v-row v-if="postImages && postImages.length > 0">
            <v-card width="100%">
              <v-card-title width="100%">
                <h2>Images</h2>
              </v-card-title>
              <v-row>
                <v-col cols="12" md="6" v-for="(image, index) in postImages" :key="index">
                  <v-card :loading="image.loading">
                    <v-card-title style="align-items: start">
                      <v-text-field
                        clearable
                        outlined
                        :rules="[rules.required]"
                        shaped
                        label="Provide a caption for your image"
                        v-model="image.imageCaption"
                      >
                      </v-text-field>
                      <v-card-actions class="pa-0 ma-0">
                        <v-btn
                          :loading="image.loadingLeft"
                          class="ma-2 info eps_white"
                          outlined
                          @click="rotateImage(image, -90)"
                          alt="Rotate Left"
                          ><i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-left theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                        <v-btn
                          :loading="image.loadingRight"
                          class="ma-2 info eps_white"
                          outlined
                          @click="rotateImage(image, 90)"
                          alt="Rotate Right"
                          ><i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-rotate-right theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                        <v-btn
                          class="ma-2 error eps_white"
                          outlined
                          @click="postImages.pop(image)"
                          alt="Remove Image"
                        >
                          <i
                            aria-hidden="true"
                            class="v-icon notranslate v-icon--center mdi mdi-delete theme--light"
                            style="font-size: 16px"
                          ></i>
                        </v-btn>
                      </v-card-actions>
                    </v-card-title>
                    <v-card elevation="6" widht="100%">
                      <v-img
                        class="ml-auto"
                        outlined
                        :src="getImageFullUrl(image.imageUrl)"
                      />
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-row>
          <v-spacer />
        </v-col>
        <v-spacer />
      </v-row>

      <v-row
        v-if="
          this.apiData &&
          this.apiData.length > 0 &&
          (this.apiData[0].image1 || this.apiData[0].image2)
        "
      >
        <v-spacer />
        <v-col cols="11" md="11">
          <v-card>
            <v-card-subtitle>Images imported from old site</v-card-subtitle>
            <v-row>
              <v-col cols="12" md="6">
                <v-card-text v-if="this.apiData[0].image1">
                  <v-card-title> {{ this.apiData[0].image1Title }}</v-card-title>
                  <v-img
                    outlined
                    :src="getOldImageUrl(this.apiData[0].userId, this.apiData[0].image1)"
                  />
                </v-card-text>
              </v-col>
              <v-col cols="12" md="6">
                <v-card-text v-if="this.apiData[0].image2">
                  <v-card-title> {{ this.apiData[0].image2Title }}</v-card-title>
                  <v-img
                    outlined
                    :src="getOldImageUrl(this.apiData[0].userId, this.apiData[0].image2)"
                  />
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-spacer />
      </v-row>

      <v-dialog v-model="showUploadImageDialog">
        <v-card :loading="imageUploading">
          <v-text-field
            class="ml-2 mr-2 pt-2"
            clearable
            outlined
            :rules="[rules.required]"
            shaped
            persistent-hint
            label="Describe your image"
            hint="No more than 200 characters"
            counter="200"
            v-model="imageCaption"
          >
          </v-text-field>
          <v-file-input
            class="ml-2 mr-2"
            outlined
            small-chips
            show-size
            accept="image/*"
            label="Select Image"
            v-model="rawFile"
          >
          </v-file-input>
          <v-row class="ml-1 mr-1">
            <v-col cols="6">
              <v-btn
                class="ma-0 error eps_white"
                outlined
                @click="closeUploadImageDialog()"
                >Cancel
                <i
                  aria-hidden="true"
                  class="v-icon notranslate v-icon--right mdi mdi-cancel theme--light"
                  style="font-size: 16px"
                ></i>
              </v-btn>
              <v-spacer />
            </v-col>
            <v-col cols="6" class="text-right">
              <v-spacer />
              <v-btn
                class="ma-0 teal eps_white"
                outlined
                @click="uploadImage()"
                :loading="imageUploading"
                >Upload<i
                  aria-hidden="true"
                  class="v-icon notranslate v-icon--right mdi mdi-camera theme--light"
                  style="font-size: 16px"
                ></i
              ></v-btn>
            </v-col>
            <v-col cols="12">
              <v-alert
                dismissible
                close-text="Close Alert"
                border="left"
                v-if="uploadImageMessage"
                :type="uploadImageStatus"
              >
                {{ uploadImageMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-container>
  </v-form>
</template>

<script
  src="https://cdn.tiny.cloud/1/obkrlht14x57mdol58bxqewvhlp88c5lwfj2i9d770gpxomq/tinymce/5/tinymce.min.js"
  referrerpolicy="origin"
></script>
<script>
import Editor from "@tinymce/tinymce-vue";
import contentUiCss from "!!raw-loader!tinymce/skins/ui/oxide/content.css";
import contentCss from "!!raw-loader!tinymce/skins/content/default/content.css";

import "tinymce/tinymce";
// /* A theme is also required */
import "tinymce/themes/silver/theme.min.js";

// /* Import the skin */
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.min.css";

import "tinymce/models/dom/model";

import "tinymce/icons/default";

/* Import plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/lists";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/emoticons/js/emojis";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/anchor";
import "tinymce/plugins/media";
import "tinymce/plugins/help";

import forumFunctions from "@/functions/forumFunctions.js";
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";

const forumObjectType = {
  POST: "Post",
  TOPIC: "Topic",
};

const modes = {
  EDIT: "edit",
  REPLY: "reply",
  QUOTE: "quote",
  NEW: "new",
  UNKNOWN: "unknown",
};

const newPostTemplate = "<br/>";

export default {
  components: {
    editor: Editor,
  },
  computed: {
    uploadImageStatus() {
      return this.uploadImageSucceeded ? "success" : "error";
    },
    userIsTopicOwner() {
      if (this.apiData && this.apiData.length > 0) {
        return this.apiData[0].topicOwner;
      }
      return false;
    },
    loggedOnUserIsAdmin() {
      return (
        userFunctions.userIsLoggedIn() &&
        (userFunctions.currentUserIsOwner() || userFunctions.currentUserIsModerator())
      );
    },
    mode() {
      switch (true) {
        case this.$route.path.indexOf("/new/") > 0:
          return modes.NEW;
        case this.$route.path.indexOf("/reply/") > 0:
          return modes.REPLY;
        case this.$route.path.indexOf("/quote/") > 0:
          return modes.QUOTE;
        case this.$route.path.indexOf("/edit/") > 0:
          return modes.EDIT;
        default:
          return modes.UNKNOWN;
      }
    },
    postIsNewTopic() {
      return this.mode == modes.NEW;
    },
    currentObjectType() {
      switch (true) {
        case this.mode == modes.REPLY:
        case this.mode == modes.QUOTE:
        case this.$route.params.post_id != null:
          return forumObjectType.POST;
        default:
          return forumObjectType.TOPIC;
      }
    },
    boardId() {
      return this.$route.params.board_id;
    },
    topicId() {
      return this.$route.params.topic_id;
    },
    postId() {
      return this.$route.params.post_id;
    },
    currentObjectId() {
      if (this.currentObjectType == forumObjectType.TOPIC && this.mode == modes.NEW) {
        return this.$route.params.board_id;
      } else {
        return this.currentObjectType == forumObjectType.TOPIC
          ? this.$route.params.topic_id
          : this.$route.params.post_id;
      }
    },
    apiOperation() {
      switch (this.mode) {
        case modes.NEW:
        case modes.REPLY:
        case modes.QUOTE:
          return "add";
        case modes.EDIT:
          return "update";
        default:
          return null;
      }
    },
    actionDescription() {
      switch (this.mode) {
        case modes.NEW:
          return "Adding a Topic to Board ";
        case modes.REPLY:
          return "Replying to Post ";
        case modes.EDIT:
          return "Editing Post ";
        default:
          return "";
      }
    },
    topicTitle() {
      return this.$route.params.title;
    },
  },
  data: () => ({
    rules: {
      required: (value) => !!value || "Required",
    },
    titleRules: [
      (v) => !!v || "Title is required",
      (v) => (v && v.length <= 150) || "Title must be less than 150 characters",
    ],
    postTitle: null,
    imageCaption: null,
    apiData: null,
    plugins: [],
    dialog: true,
    editorContent: "",
    showUploadImageDialog: false,
    contentUiCss: contentUiCss,
    contentCss: contentCss,
    imageUploading: false,
    uploadImageSucceeded: null,
    uploadImageMessage: null,
    newImage: null,
    rawFile: null,
    newImageBase64: null,
    postImages: [],
    imagesToPurge: [],
    topicSticky: false,
    topicAnnouncement: false,
    errorMessage: "",
    showError: false,
    memberRulesPanel: {
      title: "Member Rules",
      size: "medium",
      body: {
        type: "panel",
        items: [
          {
            type: "htmlpanel",
            html: `<h1>Forum Rules for the European Palm Society</h1>
          <br/>
          <p>The discussion forum exists for the benefit and enjoyment of all members but, remember it is viewable by the wider internet community. Our membership covers people of all ages, from around the world with a wide spectrum of knowledge at all levels from beginner to more experienced. It is an English language site but even if English is not your first language please always use standard English to the best you are able.</p>
          <br/>
          <p>These simple rules state what is expected of you when you participate in the forum and by registering and logging in you agree to follow these rules. They are not there to restrict discussions but to ensure the forum is a good experience for all who read and participate in it.</p>
          <br/>
          <p>If you feel someone has crossed the line in terms of behaviour please contact the Admin team 'using the 'Report Post' button and give you reasons for doing so. Do not 'retaliate' by placing inflammatory replies/posts on the forum or sending the person personal mails. Often these are sent in the heat of the moment and subsequently regretted, don't forget the written word can easily be misinterpreted and taken out of context to cause offence.</p>
          <ul>
          <li>Primarily posts should be about all aspects of palms but we do welcome posts on other plants and gardens as we recognise that many of us grow a wide range of 'exotic' plants other than palms</li>
          <li>Off topic, non plant related, posts do not have a place on this forum other than those that none the less relate to plants in some way such as photography, travel to plant habitats and gardens and our favourite subject of the weather! There are alternative, more appropriate boards and outlets for other subjects such as politics, religious beliefs, sex and venting one's frustrations!</li>
          <li>We have absolute respect for each other and there will be no tolerance to behaviour such as threatening, insulting, sniping, goading or 'attacking' other members with whose viewpoint you don't agree with.</li>
          <li>There will always from time to time be posts which you may not agree with, we all have differing opinions on things and it doesn't make another person's view wrong because it isn't the same as yours. However irritating this may be to you do not make any posts that will cause offence, this applies to the use of Personal Mails too.</li>
          <li>No swearing, bad or other inappropriate language</li>
          <li>We are not a commercial organisation and the administrators and society 'officials' give their time for free to provide this resource and keep the society on its feet – please respect them</li>
          <li>Administrator's word is final. We will of course initially seek to correct any problems directly with the violator and provide an opportunity for them to explain their behaviour. Further action will be taken as deemed appropriate in the eyes of the administrators but anybody who does not respect the simple rules will be banned from the society.</li>
          <li>Do not post any material that breaches others' copyright on the site. Quotes and extracts are acceptable but for anything longer please quote as a reference and provide a link so the reader can view the original item at source</li>
          <li>Do not use the forum for commercial purposes. There is the Swaps Forum for private swaps/trades/member small private sales and separate links to the websites of  more commercial operations.</li>
          <li>Posts made represent the personal opinion and views of the member making the post and their views expressed do not represent those of the Society, Administrators or forum in general. It is the member's responsibility to consider the content and possible legal implications arising from statements made.</li>
          </ul>
          `,
          },
        ],
      },
      buttons: [
        {
          type: "submit",
          name: "submitButton",
          text: "Close",
          buttonType: "primary",
        },
      ],
      onSubmit: (api) => {
        api.close();
      },
    },
    helpPanel: {
      title: "Posting Help",
      size: "medium",
      body: {
        type: "panel",
        items: [
          {
            type: "htmlpanel",
            html: `<h1>Welcome to General Palm Forums Help!</h1>
                  <br/>
                  <p>You can post new messages on the Palm Society forums by adding text just like you would using a word processor or email client and clicking 'Submit'.</p>
                  <br/>
                  <p>You can use the icons above the text editor to make text bold, underlined, italic, change the size and colour of the fonts and so on.</p>
                  <br/>
                  <p>You can attach images in one of three ways:</p>
                  <ul>
                    <li>You can use the 'attach image' button, which will allow you to also include a caption for the image and to rotate the images if needed</li>
                      <ul><li>You can repeat the process to upload up to 20 images, one image at a time</li></ul></li>
                    <li>You can click the 'image' icon in the toolbar (it looks like a picture of two mountains) and enter a link to the image you want to include, then click Save. This is useful if you want to include an image hosted on another website such as dropbox</li>
                    <li>You can 'paste' or 'drag' an image into the text editor directly. Please note that larger files will be automatically rejected when using this method, as uploading large files this results in slower page loading times for people viewing your post
                    <li>Use the 'insert/edit link' Icon (paperclip) to paste a URL to a site you wish to link to. This will create a live hyperlink in your post to the webpage desired</li>
                    <li>Use 'Insert/Edit media' Icon (the mountains) to select 'embed' into which you can paste the embed code from, for example, Google Maps. This will then display the map in your post</li>
                  </ul>
                  <p>Note that with the second and third method above, you may need to resize your image to make your post more readable. You can achieve this by clicking the image then clicking the 'image' icon in the toolbar, entering a number in the 'width' or 'height' box and clicking 'Save'. Try a value of 350 as a reasonable start. Alternatively, once an image is in the editor you can click on it to select it and drag the corners of the image to resize it.</p>
                  <br/>
                  <p>Happy Posting, and don't forget to read our 'Member Posting Rules' by clicking the link above!</p>
          `,
          },
        ],
      },
      buttons: [
        {
          type: "submit",
          name: "submitButton",
          text: "Close",
          buttonType: "primary",
        },
      ],
      onSubmit: (api) => {
        api.close();
      },
    },
  }),
  methods: {
    getOldImageUrl(postId, image) {
      let imageUrl = "http://old.palmsociety.org.uk/forum/images/" + postId + "/" + image;

      return "https://wsrv.nl/?url=" + imageUrl;
    },
    alertClosed() {
      this.showError = false;
    },
    editorSetup(editor) {
      editor.on("init", function (e) {
        e.target.selection.select(e.target.getBody(), true);
        e.target.selection.collapse(false);
        e.target.selection.scrollIntoView();
        e.target.focus();
        editor.execCommand("mceFocus");
      });

      editor.ui.registry.addButton("memberRulesButton", {
        text: "Rules",
        onAction: () => editor.windowManager.open(this.memberRulesPanel),
      });
      editor.ui.registry.addButton("helpButton", {
        text: "Help",
        onAction: () => editor.windowManager.open(this.helpPanel),
      });
    },
    showHelpPanel() {
      tinymce.activeEditor.windowManager.open(this.helpPanel);
    },
    showRulesPanel() {
      tinymce.activeEditor.windowManager.open(this.memberRulesPanel);
    },
    preProcessPaste(plugin, args) {
      this.errorMessage = "";
      this.showError = false;

      let url = args.content;

      if (url.indexOf("blob:") <= 0) {
        return; //not a blob, continue
      }

      args.stopImmediatePropagation();
      args.stopPropagation();
      args.preventDefault();

      let start = url.indexOf("src=") + 5;
      let end = url.lastIndexOf('"');
      url = url.substring(start, end);

      let blob = fetch(url).then((r) => r.blob());
      let maxAlowableSize = 250000; //250kb, qtr of a meg
      var pastedImageSize = -1;

      Promise.all([blob]).then((value) => {
        pastedImageSize = value[0].size;

        if (pastedImageSize <= maxAlowableSize) {
          if (args.content) {
            if (this.editorContent == null) {
              this.editorContent = "";
            }
            this.editorContent += args.content;
          } else {
            this.editorContent = "";
          }
        } else {
          this.errorMessage =
            "The image you're pasting into the window is too large - please save the image locally and use the 'Attach Image' button";
          this.showError = true;
        }
      });
    },
    topicStickyClicked() {
      if (this.topicSticky == 1) {
        this.topicAnnouncement = 0;
      }
    },
    topicAnnouncementClicked() {
      if (this.topicAnnouncement == 1) {
        this.topicSticky = 0;
      }
    },
    getImageFullUrl(imagePath) {
      return forumFunctions.getImageFullUrl(imagePath);
    },
    async resizeBase64Img(base64) {
      var canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      var image;

      const loadImagePromise = new Promise((resolve) => {
        image = new Image();
        image.onload = function () {
          let maxHeight = 1200;
          let maxWidth = 1200;
          var height = image.height;
          var width = image.width;

          let imageOverMaxHeight = height / maxHeight;
          let imageOverMaxWidth = width / maxWidth;

          if (imageOverMaxHeight > 1 && imageOverMaxHeight >= imageOverMaxWidth) {
            height *= 1 / imageOverMaxHeight;
            width *= 1 / imageOverMaxHeight;
          }

          if (imageOverMaxWidth > 1 && imageOverMaxWidth >= imageOverMaxHeight) {
            height *= 1 / imageOverMaxWidth;
            width *= 1 / imageOverMaxWidth;
          }

          canvas.height = height;
          canvas.width = width;
          context.drawImage(
            image,
            0,
            0,
            image.width,
            image.height, // source rectangle
            0,
            0,
            canvas.width,
            canvas.height
          );
          resolve();
        };
        image.src = URL.createObjectURL(base64);
      });
      await loadImagePromise;
      let reducedImageBase64 = canvas.toDataURL(base64.type, 1);
      this.newImageBase64 = reducedImageBase64.slice(reducedImageBase64.indexOf(",") + 1);
    },
    focusInput() {
      if (this.$refs.topicTitle) {
        this.$refs.topicTitle.$el.focus();
      }
    },
    readBase64Image(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.slice(reader.result.indexOf(",") + 1));
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    async uploadImage() {
      this.uploadImageSucceeded = null;
      this.uploadImageMessage = null;

      if (!this.rawFile) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage = "Please Select An Image";
        return;
      }

      this.newImage = this.rawFile;

      this.newImageBase64 = await this.readBase64Image(this.rawFile);

      while (this.newImageBase64.length > 5 * 1000 * 1000) {
        await this.resizeBase64Img(this.rawFile);
      }

      if (!this.newImage || !this.newImageBase64) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage = "Please Select An Image";
        return;
      }
      let uploadImageRequest = serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newImage.name,
        this.newImage.type,
        this.newImageBase64
      );

      this.imageUploading = true;

      let uploadImageResponse = null;

      try {
        uploadImageResponse = await serverFunctions.getPostResponse(
          "/uploadImage",
          uploadImageRequest
        );
      } catch (exception) {
        console.log(exception);
      }

      if (
        !uploadImageResponse ||
        uploadImageResponse.length == 0 ||
        !uploadImageResponse[0].success
      ) {
        this.uploadImageSucceeded = false;
        this.uploadImageMessage =
          "Image upload failed. Please check your connection and try again";
        this.imageUploading = false;
        return;
      }

      this.uploadImageSucceeded = uploadImageResponse[0].success;

      this.uploadImageMessage = this.uploadImageSucceeded
        ? "Image Uploaded"
        : uploadImageResponse[0].failureReason;

      if (this.uploadImageSucceeded) {
        this.postImages.push({
          imageCaption: this.imageCaption,
          imageUrl: uploadImageResponse[0].imagePathAndFilename,
          loading: false,
        });
        this.closeUploadImageDialog();
      }
      this.imageUploading = false;
    },
    async rotateImage(image, degrees) {
      image.loading = true;
      degrees < 0 ? (image.loadingLeft = true) : (image.loadingRight = true);

      let rotateImageRequest = serverFunctions.getRotateImageRequest(
        userFunctions.getLoggedInUser(),
        image.imageUrl,
        degrees
      );

      let rotateImageResponse = await serverFunctions.getPostResponse(
        "/rotateImage",
        rotateImageRequest
      );

      if (rotateImageResponse[0].success) {
        this.imagesToPurge.push(image.imageUrl);
        image.imageUrl = rotateImageResponse[0].uploadedFileAndPathWithoutServer;
      }
      image.loading = false;
      image.loadingLeft = false;
      image.loadingRight = false;
    },
    closeUploadImageDialog() {
      this.imageCaption = null;
      this.uploadImageSucceeded = null;
      this.uploadImageMessage = null;
      this.newImage = null;
      this.newImageBase64 = null;
      this.rawFile = null;
      this.imageUploading = false;
      this.showUploadImageDialog = false;
    },
    showUploadImage() {
      this.showUploadImageDialog = true;

      this.$nextTick(() => {
        let inputs = document.querySelectorAll('input[type="file"]');
        [...inputs].forEach((input) => {
          input.remove();
        });
      });
    },
    async imageUploadHandler(blobInfo, success, failure) {
      var imageSizeMb = blobInfo.blob().size / 1000 / 1000; // image size in mbytes
      var maxImageSizeMb = 5; // max size in mbytes
      if (imageSizeMb > maxImageSizeMb) {
        failure(
          "Image is too large ( " +
            imageSizeMb.toFixed(2) +
            " Mb), Maximum image size is " +
            maxImageSizeMb +
            " Mb"
        );
        return;
      }
      let uploadImageRequest = serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        blobInfo.filename(),
        blobInfo.blob().type,
        blobInfo.base64()
      );

      let uploadImageResponse = await serverFunctions.getPostResponse(
        "/uploadImage",
        uploadImageRequest
      );

      if (uploadImageResponse[0].success) {
        success(uploadImageResponse[0].imagePathAndFilename);
      } else {
        failure(uploadImageResponse[0].failureReason);
      }
    },
    async submitPost() {
      if (this.postTitle) {
        this.postTitle = this.postTitle.trim();
      }
      if (
        !this.$route.params.topic_id ||
        !this.$route.params.post_id ||
        this.userIsTopicOwner
      ) {
        if (
          this.postTitle == null ||
          this.postTitle.length < 1 ||
          this.postTitle.length > 150
        ) {
          let oldTopicTitle =
            this.apiData && this.apiData.length > 0 ? this.apiData[0].subject : null;
          if (oldTopicTitle == null || this.postTitle != oldTopicTitle) {
            //The
            this.errorMessage =
              "Please supply a topic title between 1 and 150 characters in length";
            this.showError = true;
            this.$refs["topicTitle"].$el.scrollIntoView(true);
            this.$refs["topicTitle"].$el.focus();
            return;
          }
        }
      }

      if (this.currentObjectType == forumObjectType.TOPIC) {
        let topicTitle = this.postTitle;
        let topicContent = this.editorContent;
        let boardId = this.currentObjectId;
        let newTopicRequest = serverFunctions.getNewTopicRequest(
          userFunctions.getLoggedInUser(),
          boardId,
          topicTitle,
          topicContent,
          this.postImages,
          this.topicSticky,
          this.topicAnnouncement
        );
        await serverFunctions.getPostResponse("/addTopic", newTopicRequest);
        this.$router.push("/forum/" + boardId);
        return;
      }

      let actionUrl = this.apiOperation == "add" ? "/addPost" : "/updatePost";
      let objectId = this.apiOperation == "add" ? this.topicId : this.postId;
      let postContent = this.editorContent;
      let topicTitle = this.postTitle;

      let postRequest = serverFunctions.getPostRequest(
        userFunctions.getLoggedInUser(),
        objectId,
        postContent,
        topicTitle,
        this.postImages
      );

      let postData = await serverFunctions.getPostResponse(actionUrl, postRequest);

      // console.log("should purge images " + this.imagesToPurge.length); TODO Purge!

      this.$router.push(
        "/post/" + postData[0].boardId + "/" + postData[0].topicId + "/" + postData[0].id
      );
    },
    cancelEdit() {
      if (this.$route.params.post_id) {
        this.$router.push(
          "/post/" +
            this.$route.params.board_id +
            "/" +
            this.$route.params.topic_id +
            "/" +
            this.$route.params.post_id
        );
      } else {
        this.$router.push("/forumboardlist");
      }
    },
    async getPostData() {
      let postId = this.$route.params.post_id;

      if (!this.apiData && this.$route.params.post_id) {
        let getPostRequest = serverFunctions.getDataRequestObject(
          userFunctions.getLoggedInUser(),
          postId
        );
        let data = await serverFunctions.getPostResponse("/getPost", getPostRequest);
        this.apiData = data;

        if (data.length > 0) {
          var postContent = forumFunctions.formatPostTextForDisplay(data[0]);
          if (this.mode === modes.QUOTE) {
            postContent =
              "<blockquote><strong>" +
              data[0].forename +
              " wrote:</strong>" +
              postContent +
              "</blockquote><br/>";
            this.apiData[0].postImages = null; //remove images from parent post for quote posts - do not repeat them!
          }
          this.editorContent = postContent;
          this.postTitle = data[0].subject;
          if (this.apiData[0].postImages) {
            for (let image in this.apiData[0].postImages) {
              this.$set(this.apiData[0].postImages[image], "loading", false);
            }
            this.postImages = this.apiData[0].postImages;
          }
        }
        if (this.$refs.editorElement && this.$refs.editorElement.element) {
          this.$refs.editorElement.element.focus();
        }
      }
    },
  },
  mounted() {
    this.$refs.userForm.validate();
    this.focusInput();
  },
  beforeMount() {
    if (this.mode === modes.EDIT || this.mode === modes.QUOTE) {
      this.getPostData();
    } else {
      this.editorContent = newPostTemplate;
    }
  },
};
</script>
